import { buildUpstreamHasFlagValidator } from './upstreamHasFlagValidator.builder';

buildUpstreamHasFlagValidator('providesVersionForBake', 'upstreamVersionProvided');
